import { render, staticRenderFns } from "./videoConfReactions.vue?vue&type=template&id=5bfe8d2c&scoped=true&lang=pug"
import script from "./videoConfReactions.vue?vue&type=script&lang=js"
export * from "./videoConfReactions.vue?vue&type=script&lang=js"
import style0 from "./videoConfReactions.vue?vue&type=style&index=0&id=5bfe8d2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe8d2c",
  null
  
)

export default component.exports